import Vue from "vue";
import zh_CN from "vee-validate/dist/locale/zh_CN";
import VeeValidate, { Validator } from "vee-validate";
import ATTR_DATA from "@/constants/ATTR_DATA";
import { checkIdCard, checkPassword, checkEmail } from "@/utils/rules";

Validator.localize("zh_CN", zh_CN);
let tipList = ["typeProblem", "server", "characterName"];
const dictionary = {
  zh_CN: {
    messages: {
      required: name =>
        tipList.includes(name)
          ? `请选择${ATTR_DATA[name]}`
          : `请输入${ATTR_DATA[name]}`,
      regex: name => `请输入有效的${ATTR_DATA[name]}`,
      min: (name, value) => {
        if (ATTR_DATA[name].indexOf("密码") != -1) {
          return `密码长度为6~32位`;
        } else if (ATTR_DATA[name].indexOf("描述") != -1) {
          return `${ATTR_DATA[name]}内容至少为${value}个字符`;
        } else {
          return `${ATTR_DATA[name]}长度至少为${value}个字符`;
        }
      }
    },
    ATTR_DATA: ATTR_DATA
  }
};
Validator.localize(dictionary);

Validator.extend("card", {
  getMessage: name => `请输入有效的${ATTR_DATA[name]}`,
  validate: value => {
    return checkIdCard(value);
  }
});
Validator.extend("password", {
  getMessage: () => `不能为连续或单一重复字符的简单密码`,
  validate: value => {
    return checkPassword(value);
  }
});

Validator.extend("email", {
  getMessage: name => `请输入有效的${ATTR_DATA[name]}`,
  validate: value => {
    return checkEmail(value);
  }
});

Vue.use(VeeValidate, {
  locale: "zh_CN"
});
